const WORKOUTS_ANALYTICS_EVENT = {
  CREATED: 'Workout Created',
  CREATED_SMART: 'Workout Created Smart',
  CREATED_FROM_RECOMMENDED: 'Workout Created From Recommended',
  CREATED_FROM_LOG: 'Workout Create From Log',
  SMART_SUGGESTIONS_RECEIVED: 'Workout Smart Suggestions Received',
  CALORIES_UPDATED: 'Workout Calories Updated',
  WORKOUT_LOG: 'Workout Log',
  DELETED: 'Workout Deleted',
  DUPLICATED: 'Workout Duplicated',
  LOGGED: 'Workout Logged'
}

export default WORKOUTS_ANALYTICS_EVENT
